import React, { useEffect, useRef, useState } from 'react';
import userImage from '../assets/user.png'
import { useNavigate } from "react-router-dom";
import '../App.css'
import './profilePhoto.css'

const ProfilePhoto = ({ translate }) => {
    const [profileImage, setProfileImage] = useState(null);
    const [error, setError] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };


    const handleLogout = () => {
        sessionStorage.clear();
        sessionStorage.clear();
        window.location.href = `/oauth2/sign_out?rd=${encodeURIComponent('/login')}`;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    // useEffect(() => {
    //     const fetchProfilePhoto = async () => {
    //         try {
    //             const response = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
    //                 method: 'GET',
    //                 headers: {
    //                     Authorization: `Bearer ${accessToken}`,
    //                 },
    //             });
    //
    //             if (response.status === 200) {
    //                 const blob = await response.blob();
    //                 const imageUrl = URL.createObjectURL(blob);
    //                 setProfileImage(imageUrl);
    //                 profileImageChange(imageUrl);
    //                 sessionStorage.setItem('profileImage', imageUrl);
    //             } else {
    //                 const errorData = await response.json();
    //                 setError(`Error: ${response.status} - ${errorData.error.message}`);
    //             }
    //         } catch (err) {
    //             setError(`Error: ${err.message}`);
    //         }
    //     };
    //
    //     if (accessToken) {
    //         fetchProfilePhoto();
    //     }
    // }, [accessToken]);

    return (
        <div ref={dropdownRef}>
            <div className="dropdown custom-dropdown">
                <div
                    className="dropdown-title custom-dropdown-toggle"
                    role="button"
                    onClick={toggleDropdown}
                >
                    <img className="profile-image" src={profileImage ? profileImage : userImage} alt="Profile" />
                </div>
                {isOpen && (
                    <ul className="dropdown-menu custom-dropdown-menu">
                        <li onClick={() => handleLogout()}>
                            <span className="dropdown-item custom-dropdown-item font-family"><img src="./logOut.svg" alt="logOutIcon"></img>{translate("Logout")}</span>
                        </li>
                    </ul>
                )}
            </div>
        </div>
    );
};

export default ProfilePhoto;
